export default "__VITE_ASSET__1dd83de7__"